
import useMediaQuery from '@material-ui/core/useMediaQuery'
import { AssignmentTurnedIn, Description } from '@material-ui/icons'
import EditContextProvider from 'Components/Hooks/ContextEdit'
import SetState from 'Components/Hooks/SetState'
import MuiDatables from 'Components/UI/Atoms/Table'
import AutocompleteFilter from 'Components/UI/Atoms/Table/Autocomplete'
import DateFilter from 'Components/UI/Atoms/Table/DatePickerFilter'
import { SUCURSAL_ORIGEN } from 'Constants'
import moment from 'moment'
import { interfaces } from 'service/interfaces'

import Edit from './Update'

const OrdersTable = (props) => {
  const { dataBefore, values, setValues, render, setRender, permissions } = props

  const windowSize = useMediaQuery('(min-width:1000px)')
  const { state: cancel, setOpen: openCancel, setClose: closeCancel } = SetState()

  const { state, setOpen, setClose } = SetState()

  const ubicacion = localStorage.getItem('ubicacion')
  const currentLocation = dataBefore?.data?.sucursal.find((u) => u.nombre === ubicacion)

  async function apiCall(options, callback) {
    const queryString =
      typeof options === 'string'
        ? `${options}&origen=ECO`
        : `${new URLSearchParams(options).toString()}&origen=ECO`
    setValues({
      rows: [],
      header: [],
    })
    try {
      const result = await interfaces.salesOrders.ordersList(`${queryString}`)
      setValues({
        rows: result.data,
        header: result.header.header.count,
      })
      callback()
    } catch (error) {}
  }

  async function orderInfo(id) {
    await interfaces.salesOrders.infoOneOrders(id).then((res) => {
      setOpen({
        data: res.data,
      })
    })
  }

  const getSucursalName = (id) => {
    const sucursal = dataBefore?.data?.sucursal.find((s) => s.id === id)
    return sucursal ? sucursal.nombre : ''
  }

  const FACTURADO = [
    {
      id: 0,
      label: 'TODOS',
    },
    {
      id: 1,
      label: 'SI',
    },
    {
      id: 2,
      label: 'NO',
    },
  ]

  const RowsTransit = () =>
    values.rows.map((file) => [
      file.estado === 1 ? (
        <Description style={{ color: '#828282' }} />
      ) : file.estado === 3 ? (
        <AssignmentTurnedIn style={{ color: '#1A9957' }} />
      ) : null,
      file.id,
      file.cliente,
      file.tipo_comprobante,
      file.origen,
      getSucursalName(file.sucursal),
      file.usuario,
      file.fecha_creacion,
      file.monto ? `$${parseFloat(file.monto)}` : '$',
      file.fecha_final,
      file.fecha_inicial,
      file.facturado,
    ])

  let columns = [
    {
      name: 'estado',
      label: 'Estado',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'id',
      label: 'Nº pedido',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'cliente',
      label: 'Cliente',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'tipo_comprobante',
      label: 'Tipo comprobante',
      options: {
        filter: false,
        sort: false,
        fullWidth: true,
      },
    },
    {
      name: 'origen',
      label: 'Origen',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(dataBefore).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Origen"
                  filterName="label"
                  options={SUCURSAL_ORIGEN}
                  defaultOption={{ label: 'ECO', id: 1 }}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'sucursal',
      label: 'Sucursal',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(dataBefore).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Sucursal"
                  filterName="nombre"
                  options={dataBefore?.data?.sucursal}
                  defaultOption={currentLocation}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'usuario',
      label: 'Usuario',
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(dataBefore).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Usuario"
                  filterName="fullName"
                  options={dataBefore.data.usuarios}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: 'fecha_creacion',
      label: 'Fecha creación',
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: 'monto',
      label: 'Monto',
      options: {
        filter: false,
        sort: false,
        fullWidth: true,
      },
    },
    {
      name: 'fecha_inicial',
      label: 'Desde',
      options: {
        filter: true,
        sort: false,
        display: false,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            return (
              <DateFilter
                filterList={filterList}
                onChange={onChange}
                index={index}
                column={column}
                label="Desde"
                selectedDate={filterList[index][0] || null}
                handleDateChange={(date) =>
                  onChange([moment(date).format('YYYY/MM/DD')], index, column)
                }
              />
            )
          },
        },
      },
    },
    {
      name: 'fecha_final',
      label: 'Hasta',
      options: {
        filter: true,
        sort: false,
        display: false,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            return (
              <DateFilter
                filterList={filterList}
                onChange={onChange}
                index={index}
                column={column}
                label="Hasta"
                selectedDate={filterList[index][0] || null}
                handleDateChange={(date) =>
                  onChange([moment(date).format('YYYY/MM/DD')], index, column)
                }
              />
            )
          },
        },
      },
    },
    {
      name: 'facturado',
      label: 'Facturado',
      options: {
        filter: true,
        sort: false,
        display: false,
        sortThirdClickReset: true,
        filterType: 'custom',
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(dataBefore).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label="Facturado"
                  filterName="label"
                  options={FACTURADO}
                  defaultOption={{ label: 'TODOS', id: 0 }}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
  ]

  return (
    <>
      {state.suspense && (
        <EditContextProvider>
          <Edit
            open={state.open}
            handleclose={setClose}
            data={state.data}
            dataBefore={dataBefore}
            openCancel={openCancel}
            cancel={cancel}
            closeCancel={closeCancel}
            render={render}
            setRender={setRender}
            orderInfo={orderInfo}
            permissions={permissions}
          />
        </EditContextProvider>
      )}

      <MuiDatables
        columns={columns}
        data={RowsTransit()}
        rows={25}
        title={`Total de pedidos: ${values.header}`}
        apiCall={apiCall}
        count={values.header}
        render={render}
        setRender={setRender}
        textPlaceholder="Buscar por nº de pedido o cliente..."
        onRowClick={(_, index) => orderInfo(values.rows[index.dataIndex].id)}
        padding={windowSize ? '10px' : ''}
      />
    </>
  )
}
export default OrdersTable
